<template>
    <div id="app" class="container-fluid h-100">

        <div class="row">
            <div id="nav" class="col-lg-12 d-none d-lg-block masthead-desktop">
                <div>
                    <div class="masthead-desktop__logo">
                        <router-link to="/tasks"><img src="./assets/logo_small.png" class="logo"/></router-link>
                    </div>
                    <ul class="masthead-desktop__nav" v-if="isAuthenticated && isOnboardingComplete">
                        <li ref="menuTaskCalendar"
                            v-bind:class="{'masthead-desktop__nav__item--selected': $route.name == 'TaskCalendar'}">
                            <router-link to="/tasks"><i class="far fa-calendar-alt"></i>Task Calendar</router-link>
                        </li>
                        <li ref="menuBookings"
                            v-bind:class="{'masthead-desktop__nav__item--selected': $route.name == 'Bookings'}">
                            <router-link to="/bookings"><i class="fas fa-bed"></i>Bookings</router-link>
                        </li>
                        <li ref="menuFormsSent"
                            v-bind:class="{'masthead-desktop__nav__item--selected': $route.name == 'FormsSent'}">
                            <router-link to="/forms"><i class="fab fa-wpforms"></i>Forms</router-link>
                        </li>
                        <li ref="menuAutomations"
                            v-bind:class="{'masthead-desktop__nav__item--selected': $route.name == 'Automations'}">
                            <router-link to="/automations"><i class="fas fa-cogs"></i>Automations</router-link>
                        </li>
                        <li v-if="canShowWhatsApp" ref="menuChats"
                            class="masthead-desktop__nav__chats"
                            v-bind:class="{'masthead-desktop__nav__item--selected': $route.name == 'GuestChats'}">
                            <router-link to="/guest-chat">
                                <i class="fas fa-comments"></i>
                                Guest Chats
                                <div v-if="numUnreadChats > 0">{{numUnreadChats}}</div>
                            </router-link>
                        </li>
                        <!--              <li><router-link to="/automations"><i class="fas fa-mail-bulk"></i>&plus;<i class="fas fa-cogs"></i><br/>Automations</router-link></li>-->
                        <!--              <li><router-link to="/configure-workflow"><i class="fas fa-cog"></i>Configuration</router-link></li>-->
                    </ul>
                    <div class="masthead-desktop__right-nav">
                        <template v-if="isAuthenticated && isOnboardingComplete">

                            <search ref="searchBar"></search>

                            <Alerts ref="alerts" v-bind:alerts="alerts" v-if="isAuthenticated"></Alerts>

                            <span ref="account" v-on:click.stop="toggleAccountMenu" class="nav-account"
                                  v-bind:class="{'nav-account__current-establishment' : showAccountMenu}">
                                <span class="d-inline d-xl-none">{{establishmentAcronym}}</span>
                                <span class="d-none d-xl-inline-block">{{establishmentNameOrAcronym}}</span>
                                <i v-show="showAccountMenu" class="fas fa-caret-up"></i>
                                <i v-show="!showAccountMenu" class="fas fa-caret-down"></i>
                            </span>

                            <div v-if="showAccountMenu" v-on:click.stop="toggleAccountMenu"
                                 v-click-outside.stop="toggleAccountMenu" class="nav-account__popup">
                                <ul>
                                    <li v-for="establishment in getEstablishments" v-bind:key="establishment.name"
                                        v-on:click="selectEstablishment(establishment.reference)"
                                        v-bind:class="{'nav-account__current-establishment' : isEstablishmentCurrentlySelected(establishment)}"
                                        class="nav-account__popup__link">
                                        {{establishment.name}}
                                    </li>
                                </ul>
                                <hr>
                                <ul>
                                    <li>
                                        <router-link to="/list-establishments" class="nav-account__popup__link" v-bind:class="{'nav-account__popup__link--standalone' : !canShowWhatsApp}">Configure Establishments</router-link>
                                    </li>
                                    <li v-if="canShowWhatsApp">
                                        <router-link to="/whatsapp-templates" class="nav-account__popup__link">WhatsApp Templates</router-link>
                                    </li>
                                </ul>
                                <hr>
                                <ul>
                                    <li>
                                        <router-link to="/account" class="nav-account__popup__link"> Account</router-link>
                                    </li>
                                    <li>
                                        <a v-on:click="showChangePasswordPopup()" class="nav-account__popup__link"> Change password</a>
                                    </li>
                                    <li>
                                        <a v-on:click="signOut()" class="nav-account__popup__sign-out nav-account__popup__link"> Sign out</a>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <div class="d-lg-none masthead-mobile">
                <div ref="mobileBurger" class="masthead-mobile__burger">
                    <Burger v-if="isAuthenticated && isOnboardingComplete"/>
                </div>
                <span class="masthead-mobile__title">
                    {{title}}
                </span>
                <template v-if="isAuthenticated && isOnboardingComplete">
                    <search ref="searchBar"></search>
                    <Alerts v-bind:alerts="alerts" v-if="isAuthenticated"/>
                </template>
            </div>
        </div>


        <Sidebar>
            <ul class="sidebar-nav" v-if="isAuthenticated && isOnboardingComplete">
                <li><img src="./assets/logo_small.png" class="logo"/></li>
                <hr>
                <li class="row" v-on:click="toggleAccountMenuMobile">
                    <div class="col-10">
                        {{establishmentNameOrAcronym}}
                        <ul v-show="showAccountMenuMobile" class="sidebar-nav-establishment-list">
                            <li v-for="establishment in getEstablishments" v-bind:key="establishment.name"
                                v-on:click="selectEstablishment(establishment.reference)"
                                v-bind:class="{'masthead-desktop__current-establishment--list-exploded' : isEstablishmentCurrentlySelected(establishment)}">
                                {{establishment.name}}
                            </li>
                        </ul>
                    </div>
                    <div class="col-2">
                        <i v-show="showAccountMenuMobile" class="fas fa-caret-up"></i>
                        <i v-show="!showAccountMenuMobile" class="fas fa-caret-down"></i>
                    </div>
                </li>
                <hr>
                <li>
                    <router-link to="/tasks"><span><i class="fas fa-calendar-alt"></i></span>Task Calendar</router-link>
                </li>
                <li>
                    <router-link to="/bookings"><span><i class="fas fa-bed"></i></span>Bookings</router-link>
                </li>
                <li>
                    <router-link to="/forms"><span><i class="fab fa-wpforms"></i></span>Forms</router-link>
                </li>
                <li>
                    <router-link to="/automations"><span><i class="fas fa-cogs"></i></span>Automations</router-link>
                </li>
                <hr>
                <li>
                    <router-link to="/list-establishments"><span><i class="fas fa-house-user"></i></span>Configure establishments
                    </router-link>
                </li>
                <hr>
                <li v-on:click="signOut()"><span><i class="fas fa-sign-out-alt"></i></span>Sign out</li>
            </ul>
        </Sidebar>

        <div class="content">
            <router-view/>
        </div>

        <confirm-dialog v-bind:message="newVersionMessage" v-bind:continuePrimaryText="'Refresh'"
                        v-bind:callbackPrimaryName="'load-new-version'" v-bind:hideCancelButton="true"
                        v-if="showNewVersionDialog"/>

        <chanage-password v-if="showChangePassword"></chanage-password>
    </div>
</template>

<script>
    import {store, mutations, getters} from '@/store.js'

    import SockJS from "sockjs-client";
    import Stomp from "webstomp-client";

    import Burger from './components/menu/Burger.vue';
    import Sidebar from './components/menu/Sidebar.vue';
    import Alerts from './components/menu/Alerts.vue';
    import Search from './components/menu/Search.vue';
    import ConfirmDialog from './components/ConfirmDialog.vue';
    import ChanagePassword from './components/ChangePassword.vue';

    // Mixins
    import {refreshPageMixin} from "./mixins/RefreshPageMixin";

    export default {
        mixins: [refreshPageMixin],
        components: {Burger, Sidebar, Alerts, Search, ConfirmDialog, ChanagePassword},
        data: function () {
            return {
                showAccountMenu: false,
                showAccountMenuMobile: false,
                showChangePassword: false,
                showNewVersionDialog: false,
                newVersionMessage: "A new version is available. Please download the new version by pressing the refresh button.",
                connectedToWebSocket: false,
                alerts: [],
                numUnreadChats: 0
            }
        },
        computed: {
            title() {
                return store.title
            },
            usersInitials: function () {
                return getters.getUsersInitials()
            },
            isAuthenticated: function () {
                console.log('checking if authenticated')
                return getters.isAuthenticated();
            },
            isOnboardingComplete: function () {
                console.log('checking if finished signup')
                return getters.isOnboardingComplete();
            },
            getEstablishments: function () {
                return store.host.establishments;
            },
            // getAlerts: function () {
            //     console.log("Binding alerts:");
            //     console.log(store.host.alerts);
            //     return store.host.alerts;
            // },
            establishmentNameOrAcronym: function () {
                let name = getters.getCurrentEstablishment().name;
                if (name.length <= 20) {
                    return name;
                }
                return this.establishmentAcronym;
            },
            establishmentAcronym: function() {
                let name = getters.getCurrentEstablishment().name;
                let acronym = name.charAt(0);
                for (let i = name.indexOf(" "); i > 0 && i < name.length; i = name.indexOf(" ", i + 1)) {
                    if (name.charAt(i + 1) !== " ") {
                        acronym += name.charAt(i + 1);
                    }
                }
                return acronym.toUpperCase();
            },
            canShowWhatsApp: function() {
                return store.host.email.startsWith("duncan");
            }
        },
        methods: {
            isEstablishmentCurrentlySelected(establishment) {
                if (getters.isAuthenticated() && getters.isOnboardingComplete() && store.currentEstablishmentReference !== undefined) {
                    return establishment.reference == store.currentEstablishmentReference
                }
            },
            toggleAccountMenu: function () {
                this.showAccountMenu = !this.showAccountMenu
            },
            toggleAccountMenuMobile: function () {
                this.showAccountMenuMobile = !this.showAccountMenuMobile
            },
            selectEstablishment: function (reference) {
                mutations.setCurrentEstablishmentReference(reference);
                mutations.hideNav();
                this.fetchCurrentEstablishmentProviderChannels();
                this.$root.$emit('selected-establishment')
            },
            showChangePasswordPopup: function() {
                this.showChangePassword = true;
            },
            hideChangePasswordPopup: function() {
                this.showChangePassword = false;
            },
            signOut: function () {
                console.log('signing out')
                this.disconnectWebSocket();
                this.$http.post('/guest-management/v1/logout'
                ).finally(response => {
                    console.log('signing out from server: ' + response);
                    this.alerts = [];
                    mutations.signOut()
                    this.$router.push({name: 'SignIn'})
                })
            },
            fetchCurrentEstablishmentProviderChannels: function () {
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/external-channels', {
                    withCredentials: true
                }).then(response => {
                    let providerChannels = [];
                    if (response.data) {
                        providerChannels.push(...response.data);
                    }
                    mutations.setCurrentEstablishmentProviderChannels(providerChannels);
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                })
            },
            fetchHostAlerts: function (callback) {
                console.log('Getting host alerts')
                this.$http.get('/guest-management/v1/users/' + store.host.reference + '/alerts').then(response => {
                    if (response.data) {
                        // mutations.setHostAlerts(response.data)
                        this.alerts.splice(0, this.alerts.length);
                        this.alerts.push(...response.data);
                    }
                    if (callback !== undefined) {
                        callback(response.data)
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            checkForWelcomeTour: function () {
                console.log('Checking for welcome tour')
                if (this.alerts != undefined && this.alerts.length > 0) {
                    const welcome = this.alerts.find(n => n.type === 'tour' && n.name === 'welcome')
                    if (welcome !== undefined) {
                        this.$root.$emit('show-welcome-tour')
                    }
                }
            },
            signedIn: function (setupComplete) {
                console.log('Signed in');
                this.fetchCurrentEstablishmentProviderChannels();
                this.connectWebSocket();
                if (setupComplete) {
                    this.fetchHostAlerts(this.checkForWelcomeTour);
                } else {
                    this.fetchHostAlerts();
                }
                this.getUnreadChatCount();
            },
            getUnreadChatCount: function() {
                console.log('Checking number of unread chats')
                this.$http.get('/guest-management/v1/companies/' + store.host.company.reference + '/chats/unread-count').then(response => {
                    if (response && !isNaN(response.data)) {
                        this.numUnreadChats = response.data;
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            startTour: function () {
                const tour = this.$shepherd({
                    useModalOverlay: true,
                    defaultStepOptions: {
                        classes: 'shepherd-popup',
                        cancelIcon: {
                            enabled: true
                        },
                        scrollTo: {behavior: 'smooth', block: 'center'}
                    }
                });

                console.log("Window width: " + window.innerWidth)

                tour.addStep({
                    id: "welcome-start",
                    text: 'Welcome to BetterGuest. Take our quick welcome tour to get started',
                    buttons: [
                        {
                            text: 'Later',
                            classes: 'btn btn-secondary',
                            action: tour.cancel
                        },
                        {
                            text: 'Start',
                            classes: 'btn btn-primary',
                            action: tour.next
                        }
                    ]
                });

                if (window.innerWidth > 576) {
                    console.log('Prepping desktop tour')
                    tour.addStep({
                        id: "task-calendar",
                        text: 'This the <b>main menu</b>. On the left is your <b>Calendar</b> showing <b>Tasks</b> such as sending an Email ' +
                            'or asking a guest to fill in a Form. Most often they are created by <b>Automations</b> that run on Bookings.',
                        attachTo: {element: this.$refs.menuTaskCalendar, on: 'bottom'},
                        buttons: [
                            {
                                text: 'Next',
                                classes: 'btn btn-primary',
                                action: tour.next
                            }
                        ]
                    });
                    tour.addStep({
                        id: "bookings",
                        text: (getters.getCurrentEstablishment().provider) ? 'These are your <b>Bookings</b>, that are synchronised with your PMS' : 'A list of your Bookings',
                        attachTo: {element: this.$refs.menuBookings, on: 'bottom'},
                        buttons: [
                            {
                                text: 'Next',
                                classes: 'btn btn-primary',
                                action: tour.next
                            }
                        ]
                    });
                    tour.addStep({
                        id: "forms-sent",
                        text: 'This is a list of <b>Forms</b> that guests have been asked to fill in, along with their responses',
                        attachTo: {element: this.$refs.menuFormsSent, on: 'bottom'},
                        buttons: [
                            {
                                text: 'Next',
                                action: tour.next
                            }
                        ]
                    });
                    tour.addStep({
                        id: "automations",
                        text: 'Here you configure your <b>Automations</b>, such as Emails and Forms. You can edit the ' +
                            'Automations you selected during sign up here.',
                        attachTo: {element: this.$refs.menuAutomations, on: 'bottom'},
                        buttons: [
                            {
                                text: 'Next',
                                action: tour.next
                            }
                        ]
                    });
                } else {
                    console.log('Prepping mobile tour')
                    tour.addStep({
                        id: "forms-sent",
                        text: 'This is your main menu. From here you can see your calendar of tasks (the current view), list forms sent to guests, and sign out.',
                        attachTo: {element: this.$refs.mobileBurger, on: 'bottom'},
                        buttons: [
                            {
                                text: 'Next',
                                action: tour.complete
                            }
                        ]
                    })
                }

                tour.on("complete", () => {
                    this.$root.$emit("tour-main-complete")
                })

                tour.start();
            },
            startAccountTour: function () {
                const tour = this.$shepherd({
                    useModalOverlay: true,
                    defaultStepOptions: {
                        classes: 'shepherd-popup',
                        cancelIcon: {
                            enabled: true
                        },
                        scrollTo: {behavior: 'smooth', block: 'center'}
                    }
                });

                if (window.innerWidth > 576) {
                    tour.addStep({
                        id: "account",
                        text: 'Your <b>account details and settings</b>. Configure variables to personalise communications, ' +
                            'set up your front-desk page and more',
                        attachTo: {element: this.$refs.account, on: 'top'},
                        buttons: [
                            {
                                text: 'Next',
                                action: tour.complete
                            }
                        ]
                    });
                }

                tour.on("complete", () => {
                    this.$router.push({name: 'Automations'});
                    this.$nextTick(() => {
                        this.startAutomationsTour();
                    })
                });

                tour.start();
            },
            startAutomationsTour: function() {
                const tour = this.$shepherd({
                    useModalOverlay: true,
                    defaultStepOptions: {
                        classes: 'shepherd-popup',
                        cancelIcon: {
                            enabled: true
                        },
                        scrollTo: {behavior: 'smooth', block: 'center'}
                    }
                });

                if (window.innerWidth > 576) {
                    tour.addStep({
                        id: "automations",
                        text: 'We\'ve switched to your Automations view to show you around' ,
                        attachTo: {element: this.$refs.menuAutomations, on: 'top'},
                        buttons: [
                            {
                                text: 'Next',
                                action: tour.complete
                            }
                        ]
                    });
                }

                tour.on("complete", () => {
                    this.$root.$emit("tour-account-complete")
                })

                tour.start();
            },
            tourComplete: function () {
                const welcome = this.alerts.find(n => n.type === 'tour' && n.name === 'welcome')
                console.log(welcome)
                this.$http.put('/guest-management/v1/users/' + store.host.reference + '/alerts/' + welcome.reference + '/acknowledged')
                    .then(() => {
                        console.log('Marked tour as watched')
                    }).catch(error => {
                    console.log(error)
                })
                console.log('Tour complete. User: ')
                console.log(store.host)
            },
            // ----------------------------------------------------------------------------
            //
            // App versioning behaviour
            //
            // ----------------------------------------------------------------------------
            setupVersionChecking: function () {
                // Register listener for new version of app
                this.initVersionCheck();

                // On every route change, check for a new version
                this.$router.beforeEach((to, from, next) => {
                    this.checkVersionTimer();
                    next();
                });
            },
            checkVersionTimer: function () {
                this.versioningTimer.runTimersCheck();
            },
            showNewVersionAvailableMessage: function () {
                this.showNewVersionDialog = true;
            },
            // ----------------------------------------------------------------------------
            //
            // WebSocket behaviour
            //
            // ----------------------------------------------------------------------------
            connectWebSocket() {
                console.log("Connecting to WebSocket on server");
                this.socket = new SockJS(process.env.VUE_APP_API_BASE_URL + '/alerts');
                this.stompClient = Stomp.over(this.socket);
                this.stompClient.connect(
                    {},
                    frame => {
                        console.log("Server responded");
                        this.connectedToWebSocket = true;
                        console.log(frame);

                        this.stompClient.subscribe("/user/queue/alerts", (message) => {
                            console.log(message);
                            let updatedAlert = JSON.parse(message.body);
                            switch (updatedAlert.state) {
                                case 'ACKNOWLEDGED':
                                case 'CANCELLED':
                                    for (let i = 0; i < this.alerts.length; i++) {
                                        if (this.alerts[i].reference == updatedAlert.reference) {
                                            this.alerts.splice(i, 1);
                                            break;
                                        }
                                    }
                                    break;
                                case 'READ':
                                    break;
                                default:
                                    this.alerts.unshift(updatedAlert);
                            }
                        });
                        this.stompClient.subscribe("/user/queue/tasks", (message) => {
                            console.log(message);
                            let task = JSON.parse(message.body);
                            this.$root.$emit('task-updated', task);
                        });
                        this.stompClient.subscribe("/user/queue/whatsapp-templates", (message) => {
                            console.log(message);
                            let template = JSON.parse(message.body);
                            this.$root.$emit('whatsapp-template-updated', template);
                        });
                        this.stompClient.subscribe("/user/queue/chats", (message) => {
                            console.log(message);
                            let chat = JSON.parse(message.body);
                            this.$root.$emit('chat-updated', chat);
                            this.$root.$emit('chat-unread-count-updated');
                        });
                    },
                    error => {
                        console.log(error);
                        this.connectedToWebSocket = false;
                    }
                );
            },
            disconnectWebSocket() {
                if (this.stompClient) {
                    this.stompClient.disconnect();
                }
                this.connectedToWebSocket = false;
            },
            // getCookie: function (cname) {
            //     let name = cname + "=";
            //     let ca = document.cookie.split(';');
            //     for (let i = 0; i < ca.length; i++) {
            //         let c = ca[i];
            //         while (c.charAt(0) == ' ') {
            //             c = c.substring(1);
            //         }
            //         if (c.indexOf(name) == 0) {
            //             return c.substring(name.length, c.length);
            //         }
            //     }
            //     return "";
            // }

            // ----------------------------------------------------------------------------
            //
            // Handle OSX Scrollbar behaviour
            //
            // ----------------------------------------------------------------------------
            areScrollbarsVisible: function() {
                let scrollableElem = document.createElement('div'),
                    innerElem = document.createElement('div');
                scrollableElem.style.width = '30px';
                scrollableElem.style.height = '30px';
                scrollableElem.style.overflow = 'scroll';
                scrollableElem.style.borderWidth = '0';
                innerElem.style.width = '30px';
                innerElem.style.height = '60px';
                scrollableElem.appendChild(innerElem);
                document.body.appendChild(scrollableElem); // Elements only have width if they're in the layout
                const diff = scrollableElem.offsetWidth - scrollableElem.clientWidth;
                document.body.removeChild(scrollableElem);
                return diff > 0;
            }
        },
        mounted() {
            this.setupVersionChecking();
            if (!this.areScrollbarsVisible()) {
                mutations.setForceScrollbars();
                document.body.classList.add('force-show-scrollbars');
            }

            // Register event listeners
            this.$root.$on('tour-search-complete', this.startAccountTour);
            this.$root.$on('tour-welcome-complete', this.tourComplete);

            this.$root.$on('check-version-timer', this.checkVersionTimer);
            this.$root.$on('new-version-available', this.showNewVersionAvailableMessage);
            this.$root.$on('load-new-version', this.reloadApp);
            this.$root.$on('show-welcome-tour', this.startTour);
            this.$root.$on('signed-in', this.signedIn);
            this.$root.$on('setup-complete', this.checkForWelcomeTour);
            this.$root.$on('finished-changing-password', this.hideChangePasswordPopup);
            this.$root.$on('chat-unread-count-updated', this.getUnreadChatCount);
        },
        beforeDestroy() {
            this.$root.$off('tour-search-complete', this.startAccountTour);
            this.$root.$off('tour-welcome-complete', this.tourComplete);

            this.$root.$off('check-version-timer', this.checkVersionTimer);
            this.$root.$off('new-version-available', this.showNewVersionAvailableMessage);
            this.$root.$off('load-new-version', this.reloadApp);
            this.$root.$off('show-welcome-tour', this.startTour)
            this.$root.$off('signed-in', this.signedIn);
            this.$root.$off('setup-complete', this.checkForWelcomeTour);
            this.$root.$off('finished-changing-password', this.hideChangePasswordPopup);
            this.$root.$off('chat-unread-count-updated', this.getUnreadChatCount);
        }
    }
</script>

<style lang="scss" scoped>
    @import "styles/global.scss";
</style>